export const devopsAndDeploymentCoordination = {
  id: 10,
  title: "DevOps and Deployment Coordination",
  activityId: 7,
  startDate: '2025-01-01',
  endDate: null,
  description: "Led 15+ developers across 5 partner companies and 3 internal departments, coordinated full software development lifecycle, implemented agile development practices across teams, and established clear communication and enabled collaboration.",
  categorizedSkills: {
    profession: [
      { name: "DevOps", weight: 1 },
      { name: "CI/CD", weight: 0.9 },
      { name: "Process Optimization", weight: 0.9 },
      { name: "Technical Documentation", weight: 0.8 }
    ],
    lead: [
      { name: "Project Management", weight: 1 },
      { name: "Engineering Leadership", weight: 0.9 },
      { name: "Technical Mentoring", weight: 0.7 },
      { name: "Cross-functional Collaboration", weight: 0.9 },
      { name: "Agile Methodologies", weight: 0.7 }
    ],
    tools: [
      { name: "Git", weight: 0.9 },
      { name: "GitHub Actions", weight: 0.8 },
      { name: "Databricks", weight: 0.7 },
      { name: "Azure", weight: 0.7 }
    ],
    language: [
      { name: "Shell", weight: 0.8 }
    ]
  },
  goal: "Lead and coordinate operational excellence through comprehensive DevOps and team management",
  detailsFile: "devops-and-deployment-coordination.md", // Reference to markdown file
  metrics: [
    "15+ developers led",
    "5 partner companies & 3 internal departments coordinated"
  ],
  role: "Engineering Team Lead (DevOps & Deployment)",
  teamSize: "15+",
  git: "inner source",
  link: "inner source",
  isProfessional: true,
  isVisible: true
};
